
export const ReadyForPOIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#clip0_17412_36132)">
            <path
                d="M7.50008 18.3337C7.96032 18.3337 8.33341 17.9606 8.33341 17.5003C8.33341 17.0401 7.96032 16.667 7.50008 16.667C7.03984 16.667 6.66675 17.0401 6.66675 17.5003C6.66675 17.9606 7.03984 18.3337 7.50008 18.3337Z"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.6666 18.3337C17.1268 18.3337 17.4999 17.9606 17.4999 17.5003C17.4999 17.0401 17.1268 16.667 16.6666 16.667C16.2063 16.667 15.8333 17.0401 15.8333 17.5003C15.8333 17.9606 16.2063 18.3337 16.6666 18.3337Z"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M0.833252 0.833008H4.16659L6.39992 11.9913C6.47612 12.375 6.68484 12.7196 6.98954 12.9649C7.29424 13.2102 7.6755 13.3405 8.06659 13.333H16.1666C16.5577 13.3405 16.9389 13.2102 17.2436 12.9649C17.5483 12.7196 17.757 12.375 17.8333 11.9913L19.1666 4.99967H4.99992"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_17412_36132">
                <rect width={20} height={20} fill="white" />
            </clipPath>
        </defs>
    </svg>
);
